import Vue from 'vue'
import Vuex from 'vuex'

Vue.use(Vuex)

export default new Vuex.Store({
  state: {
    apptoken: ''
  },
  getters: {
  },
  mutations: {
    getappToken(state, apptoken) {
      state.apptoken = apptoken
    }
  },
  actions: {
  },
  modules: {
  }
})
